import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CHECKOUT_URL, CtaButton } from './CtaButton';
import { BONUS_VALUE, REGULAR_PRICE, SALE_PRICE, TOTAL_VALUE } from '../data/content';
import { Reveal } from './Reveal';
export function FinalCtaSection() {
  return <section className="relative w-full overflow-hidden bg-steel-950 px-6 py-16 sm:py-24" aria-labelledby="closing-title" data-id="element-67" data-mp="3qrouhlxcapze">
      <div className="blueprint-grid absolute inset-0" aria-hidden="true" data-id="element-68" data-mp="2y5dsq7xzyj10" />
      <Reveal className="relative mx-auto max-w-3xl text-center" data-id="element-69" data-mp="2y314jd1nbcfi">
        <h2 id="closing-title" className="font-display text-4xl font-bold uppercase leading-[0.98] tracking-tight text-ink-50 sm:text-6xl" data-id="element-70" data-mp="334gkwrsvourk">
          Take control of your
          <span className="block text-ember-400" data-id="element-71" data-mp="3cuthxjhvqgel">classroom today</span>
        </h2>

        <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-ink-200 sm:text-lg" data-id="element-72" data-mp="2few5givxofn1">
          Don't let another weekend go to waste. Join hundreds of technical educators who are raising
          the bar for industrial training.
        </p>

        <div className="mt-9 border border-white/[0.09] bg-steel-900 p-7 sm:p-9" data-id="element-73" data-mp="2de31daha504l">
          <p className="font-display text-sm font-semibold uppercase tracking-[0.18em] text-ink-500" data-id="element-74" data-mp="28dfaqpwyqlaw">
            IIIS 2026 — 6 volumes (${REGULAR_PRICE}) + 6 bonuses (${BONUS_VALUE}) = ${TOTAL_VALUE} value
          </p>
          <p className="mt-4 flex flex-wrap items-baseline justify-center gap-x-4 gap-y-1" data-id="element-75" data-mp="1yl17fsq8l6mm">
            <span className="font-display text-2xl text-ink-500" data-id="element-76" data-mp="1ujfnjnfabs2x">
              Regular <span className="line-through" data-id="element-77" data-mp="1plml95h3ri7x">${REGULAR_PRICE}</span>
            </span>
            <span className="font-display text-6xl font-bold text-ember-400 sm:text-7xl" data-id="element-78" data-mp="1kodz6tsu2u1e">
              ${SALE_PRICE}
            </span>
          </p>
          <p className="mt-2 text-xs uppercase tracking-[0.14em] text-ink-500" data-id="element-79" data-mp="1fqm9m6fnvk0d">
            One-time payment · Lifetime access · Digital download
          </p>

          <CtaButton className="mt-8" href={CHECKOUT_URL} label="Yes! I Want To Be An Elite Instructor" data-id="element-80" data-mp="3a3kf8cqf1shd" />

          <p className="mt-6 flex items-center justify-center gap-2 text-sm text-ink-400" data-id="element-81" data-mp="18bino2bsi9us">
            <ShieldCheckIcon className="h-4 w-4 text-circuit-400" aria-hidden="true" data-id="element-82" data-mp="1d4li0coe5nc1" />
            Backed by the 7-day "First Day of Class" guarantee
          </p>
        </div>
      </Reveal>
    </section>;
}